/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AbsenceRequestCreationRequest } from '../api-models';
// @ts-ignore
import { AbsenceRequestResponse } from '../api-models';
// @ts-ignore
import { AbsenceRequestStatus } from '../api-models';
// @ts-ignore
import { ImportAbsenceResponse } from '../api-models';
// @ts-ignore
import { ScheduleStatusTypeResponse } from '../api-models';
// @ts-ignore
import { UpdateAbsenceRequestStatusRequest } from '../api-models';
/**
 * AbsencesApi - axios parameter creator
 * @export
 */
export const AbsencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets the facility\'s absence reasons for planned absence purposes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesAbsenceReasonsPlannedAbsencesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Absences/AbsenceReasons/PlannedAbsences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This should replace Assignments/absence-reasons for cleanliness and consistency.  Just need to wait until this is published in order to modify the front end.
         * @summary Gets facility\'s absence reasons for scheduler purposes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesAbsenceReasonsSchedulerGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Absences/AbsenceReasons/Scheduler`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates status of absence request.
         * @param {number} absenceRequestId 
         * @param {UpdateAbsenceRequestStatusRequest} [updateAbsenceRequestStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesAbsenceRequestAbsenceRequestIdPatch: async (absenceRequestId: number, updateAbsenceRequestStatusRequest?: UpdateAbsenceRequestStatusRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'absenceRequestId' is not null or undefined
            assertParamExists('absencesAbsenceRequestAbsenceRequestIdPatch', 'absenceRequestId', absenceRequestId)
            const localVarPath = `/Absences/AbsenceRequest/{absenceRequestId}`
                .replace(`{${"absenceRequestId"}}`, encodeURIComponent(String(absenceRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAbsenceRequestStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets absence requests based on the parameters that are not null. (for Facility Manager)
         * @param {number} [absenceRequestId] 
         * @param {number} [employeeId] 
         * @param {number} [absenceReasonId] 
         * @param {boolean} [isCallOut] 
         * @param {AbsenceRequestStatus} [absenceRequestStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesAbsenceRequestsGet: async (absenceRequestId?: number, employeeId?: number, absenceReasonId?: number, isCallOut?: boolean, absenceRequestStatus?: AbsenceRequestStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Absences/AbsenceRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (absenceRequestId !== undefined) {
                localVarQueryParameter['absenceRequestId'] = absenceRequestId;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (absenceReasonId !== undefined) {
                localVarQueryParameter['absenceReasonId'] = absenceReasonId;
            }

            if (isCallOut !== undefined) {
                localVarQueryParameter['isCallOut'] = isCallOut;
            }

            if (absenceRequestStatus !== undefined) {
                localVarQueryParameter['absenceRequestStatus'] = absenceRequestStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates an absence request.
         * @param {AbsenceRequestCreationRequest} [absenceRequestCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesEmployeeAbsenceRequestPost: async (absenceRequestCreationRequest?: AbsenceRequestCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Absences/Employee/AbsenceRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(absenceRequestCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets absence requests based on the parameters that are not null. (for Employee)
         * @param {number} [absenceRequestId] 
         * @param {number} [employeeId] 
         * @param {number} [absenceReasonId] 
         * @param {boolean} [isCallOut] 
         * @param {AbsenceRequestStatus} [absenceRequestStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesEmployeeAbsenceRequestsGet: async (absenceRequestId?: number, employeeId?: number, absenceReasonId?: number, isCallOut?: boolean, absenceRequestStatus?: AbsenceRequestStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Absences/Employee/AbsenceRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (absenceRequestId !== undefined) {
                localVarQueryParameter['absenceRequestId'] = absenceRequestId;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (absenceReasonId !== undefined) {
                localVarQueryParameter['absenceReasonId'] = absenceReasonId;
            }

            if (isCallOut !== undefined) {
                localVarQueryParameter['isCallOut'] = isCallOut;
            }

            if (absenceRequestStatus !== undefined) {
                localVarQueryParameter['absenceRequestStatus'] = absenceRequestStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [proStartDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesImportAbsencesGet: async (proStartDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Absences/import-absences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (proStartDate !== undefined) {
                localVarQueryParameter['proStartDate'] = (proStartDate as any instanceof Date) ?
                    (proStartDate as any).toISOString() :
                    proStartDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AbsencesApi - functional programming interface
 * @export
 */
export const AbsencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AbsencesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets the facility\'s absence reasons for planned absence purposes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absencesAbsenceReasonsPlannedAbsencesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ScheduleStatusTypeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absencesAbsenceReasonsPlannedAbsencesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This should replace Assignments/absence-reasons for cleanliness and consistency.  Just need to wait until this is published in order to modify the front end.
         * @summary Gets facility\'s absence reasons for scheduler purposes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absencesAbsenceReasonsSchedulerGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ScheduleStatusTypeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absencesAbsenceReasonsSchedulerGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates status of absence request.
         * @param {number} absenceRequestId 
         * @param {UpdateAbsenceRequestStatusRequest} [updateAbsenceRequestStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absencesAbsenceRequestAbsenceRequestIdPatch(absenceRequestId: number, updateAbsenceRequestStatusRequest?: UpdateAbsenceRequestStatusRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbsenceRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absencesAbsenceRequestAbsenceRequestIdPatch(absenceRequestId, updateAbsenceRequestStatusRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets absence requests based on the parameters that are not null. (for Facility Manager)
         * @param {number} [absenceRequestId] 
         * @param {number} [employeeId] 
         * @param {number} [absenceReasonId] 
         * @param {boolean} [isCallOut] 
         * @param {AbsenceRequestStatus} [absenceRequestStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absencesAbsenceRequestsGet(absenceRequestId?: number, employeeId?: number, absenceReasonId?: number, isCallOut?: boolean, absenceRequestStatus?: AbsenceRequestStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AbsenceRequestResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absencesAbsenceRequestsGet(absenceRequestId, employeeId, absenceReasonId, isCallOut, absenceRequestStatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates an absence request.
         * @param {AbsenceRequestCreationRequest} [absenceRequestCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absencesEmployeeAbsenceRequestPost(absenceRequestCreationRequest?: AbsenceRequestCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbsenceRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absencesEmployeeAbsenceRequestPost(absenceRequestCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets absence requests based on the parameters that are not null. (for Employee)
         * @param {number} [absenceRequestId] 
         * @param {number} [employeeId] 
         * @param {number} [absenceReasonId] 
         * @param {boolean} [isCallOut] 
         * @param {AbsenceRequestStatus} [absenceRequestStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absencesEmployeeAbsenceRequestsGet(absenceRequestId?: number, employeeId?: number, absenceReasonId?: number, isCallOut?: boolean, absenceRequestStatus?: AbsenceRequestStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AbsenceRequestResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absencesEmployeeAbsenceRequestsGet(absenceRequestId, employeeId, absenceReasonId, isCallOut, absenceRequestStatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [proStartDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absencesImportAbsencesGet(proStartDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ImportAbsenceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absencesImportAbsencesGet(proStartDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AbsencesApi - factory interface
 * @export
 */
export const AbsencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AbsencesApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets the facility\'s absence reasons for planned absence purposes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesAbsenceReasonsPlannedAbsencesGet(options?: AxiosRequestConfig): AxiosPromise<Array<ScheduleStatusTypeResponse>> {
            return localVarFp.absencesAbsenceReasonsPlannedAbsencesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * This should replace Assignments/absence-reasons for cleanliness and consistency.  Just need to wait until this is published in order to modify the front end.
         * @summary Gets facility\'s absence reasons for scheduler purposes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesAbsenceReasonsSchedulerGet(options?: AxiosRequestConfig): AxiosPromise<Array<ScheduleStatusTypeResponse>> {
            return localVarFp.absencesAbsenceReasonsSchedulerGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates status of absence request.
         * @param {AbsencesApiAbsencesAbsenceRequestAbsenceRequestIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesAbsenceRequestAbsenceRequestIdPatch(requestParameters: AbsencesApiAbsencesAbsenceRequestAbsenceRequestIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<AbsenceRequestResponse> {
            return localVarFp.absencesAbsenceRequestAbsenceRequestIdPatch(requestParameters.absenceRequestId, requestParameters.updateAbsenceRequestStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets absence requests based on the parameters that are not null. (for Facility Manager)
         * @param {AbsencesApiAbsencesAbsenceRequestsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesAbsenceRequestsGet(requestParameters: AbsencesApiAbsencesAbsenceRequestsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<AbsenceRequestResponse>> {
            return localVarFp.absencesAbsenceRequestsGet(requestParameters.absenceRequestId, requestParameters.employeeId, requestParameters.absenceReasonId, requestParameters.isCallOut, requestParameters.absenceRequestStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates an absence request.
         * @param {AbsencesApiAbsencesEmployeeAbsenceRequestPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesEmployeeAbsenceRequestPost(requestParameters: AbsencesApiAbsencesEmployeeAbsenceRequestPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<AbsenceRequestResponse> {
            return localVarFp.absencesEmployeeAbsenceRequestPost(requestParameters.absenceRequestCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets absence requests based on the parameters that are not null. (for Employee)
         * @param {AbsencesApiAbsencesEmployeeAbsenceRequestsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesEmployeeAbsenceRequestsGet(requestParameters: AbsencesApiAbsencesEmployeeAbsenceRequestsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<AbsenceRequestResponse>> {
            return localVarFp.absencesEmployeeAbsenceRequestsGet(requestParameters.absenceRequestId, requestParameters.employeeId, requestParameters.absenceReasonId, requestParameters.isCallOut, requestParameters.absenceRequestStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AbsencesApiAbsencesImportAbsencesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesImportAbsencesGet(requestParameters: AbsencesApiAbsencesImportAbsencesGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<ImportAbsenceResponse>> {
            return localVarFp.absencesImportAbsencesGet(requestParameters.proStartDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for absencesAbsenceRequestAbsenceRequestIdPatch operation in AbsencesApi.
 * @export
 * @interface AbsencesApiAbsencesAbsenceRequestAbsenceRequestIdPatchRequest
 */
export interface AbsencesApiAbsencesAbsenceRequestAbsenceRequestIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof AbsencesApiAbsencesAbsenceRequestAbsenceRequestIdPatch
     */
    readonly absenceRequestId: number

    /**
     * 
     * @type {UpdateAbsenceRequestStatusRequest}
     * @memberof AbsencesApiAbsencesAbsenceRequestAbsenceRequestIdPatch
     */
    readonly updateAbsenceRequestStatusRequest?: UpdateAbsenceRequestStatusRequest
}

/**
 * Request parameters for absencesAbsenceRequestsGet operation in AbsencesApi.
 * @export
 * @interface AbsencesApiAbsencesAbsenceRequestsGetRequest
 */
export interface AbsencesApiAbsencesAbsenceRequestsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AbsencesApiAbsencesAbsenceRequestsGet
     */
    readonly absenceRequestId?: number

    /**
     * 
     * @type {number}
     * @memberof AbsencesApiAbsencesAbsenceRequestsGet
     */
    readonly employeeId?: number

    /**
     * 
     * @type {number}
     * @memberof AbsencesApiAbsencesAbsenceRequestsGet
     */
    readonly absenceReasonId?: number

    /**
     * 
     * @type {boolean}
     * @memberof AbsencesApiAbsencesAbsenceRequestsGet
     */
    readonly isCallOut?: boolean

    /**
     * 
     * @type {AbsenceRequestStatus}
     * @memberof AbsencesApiAbsencesAbsenceRequestsGet
     */
    readonly absenceRequestStatus?: AbsenceRequestStatus
}

/**
 * Request parameters for absencesEmployeeAbsenceRequestPost operation in AbsencesApi.
 * @export
 * @interface AbsencesApiAbsencesEmployeeAbsenceRequestPostRequest
 */
export interface AbsencesApiAbsencesEmployeeAbsenceRequestPostRequest {
    /**
     * 
     * @type {AbsenceRequestCreationRequest}
     * @memberof AbsencesApiAbsencesEmployeeAbsenceRequestPost
     */
    readonly absenceRequestCreationRequest?: AbsenceRequestCreationRequest
}

/**
 * Request parameters for absencesEmployeeAbsenceRequestsGet operation in AbsencesApi.
 * @export
 * @interface AbsencesApiAbsencesEmployeeAbsenceRequestsGetRequest
 */
export interface AbsencesApiAbsencesEmployeeAbsenceRequestsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AbsencesApiAbsencesEmployeeAbsenceRequestsGet
     */
    readonly absenceRequestId?: number

    /**
     * 
     * @type {number}
     * @memberof AbsencesApiAbsencesEmployeeAbsenceRequestsGet
     */
    readonly employeeId?: number

    /**
     * 
     * @type {number}
     * @memberof AbsencesApiAbsencesEmployeeAbsenceRequestsGet
     */
    readonly absenceReasonId?: number

    /**
     * 
     * @type {boolean}
     * @memberof AbsencesApiAbsencesEmployeeAbsenceRequestsGet
     */
    readonly isCallOut?: boolean

    /**
     * 
     * @type {AbsenceRequestStatus}
     * @memberof AbsencesApiAbsencesEmployeeAbsenceRequestsGet
     */
    readonly absenceRequestStatus?: AbsenceRequestStatus
}

/**
 * Request parameters for absencesImportAbsencesGet operation in AbsencesApi.
 * @export
 * @interface AbsencesApiAbsencesImportAbsencesGetRequest
 */
export interface AbsencesApiAbsencesImportAbsencesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AbsencesApiAbsencesImportAbsencesGet
     */
    readonly proStartDate?: string
}

/**
 * AbsencesApi - object-oriented interface
 * @export
 * @class AbsencesApi
 * @extends {BaseAPI}
 */
export class AbsencesApi extends BaseAPI {
    /**
     * 
     * @summary Gets the facility\'s absence reasons for planned absence purposes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public absencesAbsenceReasonsPlannedAbsencesGet(options?: AxiosRequestConfig) {
        return AbsencesApiFp(this.configuration).absencesAbsenceReasonsPlannedAbsencesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This should replace Assignments/absence-reasons for cleanliness and consistency.  Just need to wait until this is published in order to modify the front end.
     * @summary Gets facility\'s absence reasons for scheduler purposes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public absencesAbsenceReasonsSchedulerGet(options?: AxiosRequestConfig) {
        return AbsencesApiFp(this.configuration).absencesAbsenceReasonsSchedulerGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates status of absence request.
     * @param {AbsencesApiAbsencesAbsenceRequestAbsenceRequestIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public absencesAbsenceRequestAbsenceRequestIdPatch(requestParameters: AbsencesApiAbsencesAbsenceRequestAbsenceRequestIdPatchRequest, options?: AxiosRequestConfig) {
        return AbsencesApiFp(this.configuration).absencesAbsenceRequestAbsenceRequestIdPatch(requestParameters.absenceRequestId, requestParameters.updateAbsenceRequestStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets absence requests based on the parameters that are not null. (for Facility Manager)
     * @param {AbsencesApiAbsencesAbsenceRequestsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public absencesAbsenceRequestsGet(requestParameters: AbsencesApiAbsencesAbsenceRequestsGetRequest = {}, options?: AxiosRequestConfig) {
        return AbsencesApiFp(this.configuration).absencesAbsenceRequestsGet(requestParameters.absenceRequestId, requestParameters.employeeId, requestParameters.absenceReasonId, requestParameters.isCallOut, requestParameters.absenceRequestStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates an absence request.
     * @param {AbsencesApiAbsencesEmployeeAbsenceRequestPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public absencesEmployeeAbsenceRequestPost(requestParameters: AbsencesApiAbsencesEmployeeAbsenceRequestPostRequest = {}, options?: AxiosRequestConfig) {
        return AbsencesApiFp(this.configuration).absencesEmployeeAbsenceRequestPost(requestParameters.absenceRequestCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets absence requests based on the parameters that are not null. (for Employee)
     * @param {AbsencesApiAbsencesEmployeeAbsenceRequestsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public absencesEmployeeAbsenceRequestsGet(requestParameters: AbsencesApiAbsencesEmployeeAbsenceRequestsGetRequest = {}, options?: AxiosRequestConfig) {
        return AbsencesApiFp(this.configuration).absencesEmployeeAbsenceRequestsGet(requestParameters.absenceRequestId, requestParameters.employeeId, requestParameters.absenceReasonId, requestParameters.isCallOut, requestParameters.absenceRequestStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AbsencesApiAbsencesImportAbsencesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public absencesImportAbsencesGet(requestParameters: AbsencesApiAbsencesImportAbsencesGetRequest = {}, options?: AxiosRequestConfig) {
        return AbsencesApiFp(this.configuration).absencesImportAbsencesGet(requestParameters.proStartDate, options).then((request) => request(this.axios, this.basePath));
    }
}
